import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../../shared/service/auth-service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToasterCommonService } from '../../shared/service/toaster-common-service';
import { BrowserStorageService } from '../../shared/service/browser-storage-service';
import { CustomValidators } from './custom-validators';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ThemeService } from '../../shared/service/theme-service';
@Component({
  selector: 'app-first-time-password-change',
  standalone: false,
  templateUrl: './first-time-password-change.html',
  styleUrl: './first-time-password-change.scss'
})
export class FirstTimePasswordChange implements OnInit {
  private browserStorage = inject(BrowserStorageService);
  public themeService = inject(ThemeService);

  passwordForm!: FormGroup;
  password_show_and_hide = false;
  conf_password_show_and_hide = false;
  loading = false;
  currentYear: number = new Date().getFullYear();
  constructor(
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToasterCommonService,
    private bottomSheet: MatBottomSheet
  ) {}

  ngOnInit() {
    this.passwordForm = new FormGroup({
      email: new FormControl(this.browserStorage.getSessionItem("email")),
      temp_password: new FormControl('', [Validators.required, Validators.maxLength(128)]),
      confirm_password: new FormControl('', [Validators.required, Validators.maxLength(128)]),
      password: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          // check whether the entered password has a number
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true,
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          // check whether the entered password has a special character
          CustomValidators.patternValidator(
            /[ !@#$%^&*()_+\-_=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true,
            }
          ),
          Validators.minLength(8),
          Validators.maxLength(128),
        ])
      ),
    }, { validators: CustomValidators.passwordMatchValidator });
  }

  passwordUpdate(ngForm: NgForm) {
    this.spinner.show();
    this.authService.tempPasswordChanged(ngForm).subscribe({
      next: (data) => {
        if (data.status == 200) {
          this.browserStorage.removeSessionItem('email');
          this.signIn();
          this.toastr.showSuccess(data.message, '');
          this.spinner.hide();
        } else {
          this.toastr.showError(data.message, '');
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.toastr.showError(
          'Your backend server is not working, Please connect with Admin!',
          ''
        );
        this.loading = false;
      },
    });
  }

  signUp() {
    this.router.navigate(['auth','sign-up'], {
      replaceUrl: true,
    });
  }
  goToHome() {
    this.router.navigate([''], {
      replaceUrl: true,
    });
  }
  signIn(){
    this.router.navigate(['auth','sign-in'], {
      replaceUrl: true,
    });
  }

  
}
